import { GridState, Loadable } from '..';
import { HashMap } from '../../constants';
import { FilterSettingsState, getDefaultFilterSettingsState } from '../../models/state/filterSettingsState';
import { getDefaultUserRolesState, UserRoles } from '../../models/state/userRolesState';
import { getDefaultLoginDetails, LoginDetails } from '../loginDetails';
import { AvailableTelsState, getDefaultAvailableTelsState } from './availableTelsState';
import { BundleAlertDefinitionsState, getDefaultBundleAlertDefinitionState } from './bundleAlertDefinitionsState';
import { CommandDefinitionsState } from './commandDefinitionState';
import { CommandTypesState, getDefaultCommandTypesState } from './commandTypeState';
import { getDefaultMvnoBundleState, MvnoBundleState } from './mvnoBundle';
import { getDefaultNotificationState, NotificationState } from './notificationState';
import { getDefaultSimProvisionState } from './simProvision/defaults';
import {
  AccountOrangeZonesState,
  DropdownItemsState,
  getDefaultMvnoTemplatesState,
  MvnoTemplatesState,
  SimProvisionState,
  SubmissionState,
} from './simProvision/simProvisionState';
import { getDefaultSimsState, SimsState } from './simsState';
import { getDefaultSubmissionState } from './submissionDefaults';
import { getDefaultSubmissionsState, SubmissionsState } from './submissionsState';
import { getDefaultUserCommandTypesState, UserCommandTypes } from './userCommandTypesState';
import { getDefaultUserSettingsState, UserSettingsState } from './userSettings';

/**
 * Interface which represents the root of the application state.
 */
export interface AppState {
  availableTels: AvailableTelsState;
  bundleAlertDefinitions: BundleAlertDefinitionsState;
  commandDefinitions: CommandDefinitionsState;
  commandTypes: CommandTypesState;
  filter: FilterSettingsState;
  grid: HashMap<GridState>;
  loginDetails: LoginDetails;
  notifications: NotificationState;
  mvnoTemplates: MvnoTemplatesState;
  mvnoBundle: MvnoBundleState;
  portNetworks: DropdownItemsState;
  sims: SimsState;
  simProvisionState: SimProvisionState;
  submission: SubmissionState;
  submissions: SubmissionsState;
  userCommandTypes: Loadable<UserCommandTypes>;
  userRoles: Loadable<UserRoles>;
  userSettings: UserSettingsState;
}

/**
 * Generates the initial startup state of the application.
 */
export const initialAppState: AppState = {
  availableTels: getDefaultAvailableTelsState(),
  bundleAlertDefinitions: getDefaultBundleAlertDefinitionState(),
  commandDefinitions: {},
  commandTypes: getDefaultCommandTypesState(),
  filter: getDefaultFilterSettingsState(),
  grid: {},
  loginDetails: getDefaultLoginDetails(),
  mvnoTemplates: getDefaultMvnoTemplatesState(),
  mvnoBundle: getDefaultMvnoBundleState(),
  portNetworks: {},
  notifications: getDefaultNotificationState(),
  simProvisionState: getDefaultSimProvisionState(),
  sims: getDefaultSimsState(),
  submission: getDefaultSubmissionState(),
  submissions: getDefaultSubmissionsState(),
  userCommandTypes: getDefaultUserCommandTypesState(),
  userRoles: getDefaultUserRolesState(),
  userSettings: getDefaultUserSettingsState(),
};
